import React, {useContext, useEffect, useState} from "react";
import {post} from "../../util/api";

export const PricesContext = React.createContext(null);

export function usePrices() {
    return useContext(PricesContext)
}

export function PricesProvider({ children, countryCode }) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [prices, setPrices] = useState({});

    useEffect(() => {
        (async () => {
            try {
                const loadedPrices = await post(`/api/price/getpricelist`, {
                    countryCode,
                });
                setPrices(loadedPrices);
            } catch (e) {
                setError(e.message);
            }
            setLoading(false);
        })()
    }, [countryCode]);

    const value = {
        country: countryCode,
        treatmentPrices: prices.treatmentPackageBrutPrices,
    };

    return (
        <PricesContext.Provider value={value}>
            {error && <div className="alert alert-danger" role="alert">
                <i className="fa fa-exclamation-circle"/>
                {error}
            </div>}
            {!loading && children}
            {loading && <div>Loading...</div>}
        </PricesContext.Provider>
    )
}



// WEBPACK FOOTER //
// ./src/modules/sales/PricesContext.js